import { render, staticRenderFns } from "./HoursPerWorkingDayWarning.vue?vue&type=template&id=3778c48c"
import script from "./HoursPerWorkingDayWarning.vue?vue&type=script&lang=js"
export * from "./HoursPerWorkingDayWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports